// src/main.jsx
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import App from './App';
import LoginPage from './pages/LoginPage';
import './index.css';
import useGlobale from './components/global';
import DashboardLayout from './pages/DashboardLayout';
import DepotsTable from './pages/DepotListePage';
import EditDepotPage from './pages/EditDepotPage';
import DetailDepotPage from './pages/DetailDepotPage';
import StateByRegion  from './pages/StateByRegion';
import StatByDepartement from './pages/StatByDepartement';
import StateByCommune from './pages/StateByCommune';
import CreateRapport from './pages/CreateRapport';
import UtilisateurPage from './pages/UtilisateurPage';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CreateDepotPage from './pages/CreateDepot';
import SettingPage from './pages/SettingPage';
import PermissionPage from './pages/PermissionPage';
import StateGeneralPage from './pages/StateGeneralPage';
import StateByIndicateurPage from './pages/StateByIndicateurPage';

const PrivateRoute = ({ element: Component }) => {
  const authenticated = useGlobale(state => state.authenticated_collecte);
  const checkAuth = useGlobale(state => state.checkAuth);
  const location = useLocation();
  // console.log(authenticated)
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (!authenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return Component;
};

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Routes publiques */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        
        {/* Routes protégées */}
        <Route path="/dashboard" element={<PrivateRoute element={<DashboardLayout />} />} />
        <Route path="/depots" element={<PrivateRoute element={<DepotsTable />} />} />
        <Route path="/depots/:id/edit" element={<PrivateRoute element={<EditDepotPage />} />} />
        <Route path="/depots/:id" element={<PrivateRoute element={<DetailDepotPage />} />} />
        <Route path="/stats/regions" element={<PrivateRoute element={<StateByRegion />} />} />
        <Route path="/stats/departements" element={<PrivateRoute element={<StatByDepartement />} />} />
        <Route path="/stats/communes" element={<PrivateRoute element={<StateByCommune />} />} />
        <Route path="/rapports/create" element={<PrivateRoute element={<CreateRapport />} />} />
        <Route path="/utilisateurs" element={<PrivateRoute element={<UtilisateurPage />} />} />
        <Route path="/depots/create" element={<PrivateRoute element={<CreateDepotPage />} />} />
        <Route path="/settings" element={<PrivateRoute element={<SettingPage />} />} />
        <Route path="/permissions/:userId" element={<PrivateRoute element={<PermissionPage />} />} />
        <Route path="/stats/general" element={<PrivateRoute element={<StateGeneralPage />} />} />
        <Route path="/stats/indicateurs" element={<PrivateRoute element={<StateByIndicateurPage />} />} />  
        
      </Routes>
    </BrowserRouter>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);